// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 22 2023
 **/

import { forwardRef, Ref } from "react";
import { IconProps } from "../Icon";
import Svg from "@/frameworks/designStuff/components/Contents/Icon/Svg";
const AudioExtension = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy: string | undefined = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 37 36"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<rect x={0.16626} width={36} height={36} rx={8} fill="#B16FCB" />
				<g opacity={0.8}>
					<path
						d="M26.1245 21.9602C26.2589 23.6241 24.919 25.1394 23.1276 25.3477C21.3393 25.5541 19.7747 24.3734 19.6414 22.7095C19.5049 21.0475 20.85 19.5303 22.6382 19.3239C23.2042 19.2593 23.7461 19.3317 24.2301 19.5147V12.9078L15.8297 14.3634V23.0069H15.8129C15.8171 23.0352 15.8244 23.0616 15.8244 23.091C15.9599 24.7549 14.6189 26.2682 12.8296 26.4766C11.0372 26.683 9.4789 25.5023 9.34344 23.8403C9.20588 22.1764 10.5479 20.6592 12.3382 20.4547C12.9042 20.3882 13.446 20.4625 13.9301 20.6474V10.4457V10.4427L26.116 8.50391L26.1276 8.5V8.50196L26.1318 8.5L26.1276 8.55185V21.877H26.1108C26.116 21.9064 26.1224 21.9308 26.1245 21.9602Z"
						fill="white"
					/>
				</g>
			</Svg>
		);
	}
);
AudioExtension.defaultProps = {
	size: 36,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default AudioExtension;
